import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{contactData.title}</h2>
          <p className="text-sm text-foreground-500 mb-3">{contactData.subtitle}</p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">{contactData.description}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <div className="flex items-center gap-3 bg-background-100 rounded-xl px-6 py-4 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <div className="text-left">
                <span className="block text-xs text-foreground-400">电子邮箱</span>
                <span className="text-sm font-medium text-foreground-800">{contactData.email}</span>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-100 rounded-xl px-6 py-4 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                <i className="ri-wechat-line text-accent-500 text-lg"></i>
              </div>
              <div className="text-left">
                <span className="block text-xs text-foreground-400">微信</span>
                <span className="text-sm font-medium text-foreground-800">{contactData.wechat}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}